import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {BonusBunniesReelSymbol} from "../../symbols/BonusBunniesReelSymbol";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";

/**
 * Created by Jerker Nord on 2019-09-11.
 */

export class BonusBunniesStickyBonusValueContainer extends PIXI.Sprite {

    private _valueText:PIXI.BitmapText;
    private _duplicateValueTextPosition:PIXI.Point;
    private _currentValue:number = 0;
    private _reel:number;
    private _row:number;

    constructor(reel:number, row:number) {
        super();
        this._reel = reel;
        this._row = row;
    }

    public init():void {
        this._valueText = new PIXI.BitmapText("", {
            fontName:BonusBunniesGameConfig.TEXT_STYLES.MULTIPLIER_TEXT_STYLE.font.name!,
            fontSize:BonusBunniesGameConfig.TEXT_STYLES.MULTIPLIER_TEXT_STYLE.font.size
        });
        this._valueText.position.y = 46;
        this._valueText.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._valueText);
    }

    public reset():void {
    }

    set stickySym(sym:string) {
    }

    set valueText(value:number) {
        this._valueText.text = "x" + value.toString();
        BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView.duplicateValues[this.reel][this.row].text = "x" + value.toString();
        this._currentValue = value;
    }

    public getValueText():PIXI.BitmapText {
        return this._valueText;
    }

    get duplicateValueText():PIXI.BitmapText {
        return BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView.duplicateValues[this.reel][this.row];
    }

    public resetDuplicateValueText():void {
        BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView.duplicateValues[this.reel][this.row].visible = false;
        BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView.duplicateValues[this.reel][this.row].position = this._duplicateValueTextPosition;
    }

    get duplicateValueTextPosition():PIXI.Point {
        return this._duplicateValueTextPosition;
    }

    set duplicateValueTextPosition(value:PIXI.Point) {
        this._duplicateValueTextPosition = value;
        this.duplicateValueText.position = value;
    }

    get currentValue():number {
        return this._currentValue;
    }

    set currentValue(value:number) {
        this._currentValue = value;
    }

    get reel():number {
        return this._reel;
    }

    get row():number {
        return this._row;
    }
}